/* unplugin-vue-components disabled */import { render } from "./indexHebei.vue?vue&type=template&id=54bf602f"
import script from "./indexHebei.vue?vue&type=script&lang=js"
export * from "./indexHebei.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__